import zh from './zh-CN';
import en from './en-US';
import ja from './ja-JP';

export default {
    zh,
    en,
    ja
};
